export default __webpack_public_path__ + "7549371.png";